<template>
    <div class="Estudiante">
        <v-container grid-list-xl fluid v-show="!showDetails" class="pt-0">
            <v-layout row wrap>
                <v-flex sm12>
                    <v-card>
                        <v-toolbar color="primary" dark flat>
                            <v-toolbar-title>
                                <v-icon medium>fa fa-graduation-cap</v-icon>
                                Lista de Estudiantes
                            </v-toolbar-title>

                            <v-divider class="mx-2" inset vertical></v-divider>

                            <v-flex sm3 class="pa-0" style="max-width: 190px">
                                <v-overflow-btn
                                    v-model="estudianteEstado"
                                    label="Estudiantes"
                                    :items="[
                                        { text: 'Todos', value: '1' },
                                        { text: 'Habilitados', value: '2' },
                                        { text: 'Deshabilitados', value: '3' }
                                    ]"
                                    hide-details
                                    class="pa-0"
                                    @change="loadEstudiante()"
                                >
                                    <template v-slot:item="data">
                                        <v-list-tile-content>
                                            <v-card-text class="pa-0 ">
                                                <v-icon
                                                    :color="getIconColor(data)"
                                                    class="pr-3"
                                                    v-if="data.item.value !== '1'"
                                                >fa-list</v-icon
                                                >
                                                {{ data.item.text }}
                                            </v-card-text>
                                        </v-list-tile-content>
                                    </template>
                                </v-overflow-btn>
                            </v-flex>

                            <v-divider class="px-1" inset vertical></v-divider>

                            <v-spacer></v-spacer>

                            <v-toolbar-items>
                                <v-btn icon @click="toogleSearch()">
                                    <v-icon medium>fa fa-search</v-icon>
                                </v-btn>

                                <v-expand-x-transition>
                                    <v-text-field
                                        hide-details
                                        solo
                                        v-show="searchShow"
                                        v-model="filter.search"
                                        placeholder="Filtrar"
                                        class="hidden-sm-and-down pt-2"
                                    >
                                    </v-text-field>
                                </v-expand-x-transition>

                                <v-menu
                                    v-model="filtroMenu"
                                    origin="center center"
                                    class="elelvation-1"
                                    transition="slide-y-transition"
                                    top
                                    left
                                    min-width="500"
                                    max-height="500"
                                    :close-on-content-click="false"
                                >
                                    <template v-slot:activator="{ on: menu }">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on: tooltip }">
                                                <v-btn icon flat>
                                                    <v-badge color="orange" overlap>
                                                        <span slot="badge" v-if="activeFilters > 0">{{
                                                            activeFilters
                                                        }}</span>
                                                        <v-icon medium v-on="{ ...tooltip, ...menu }">fa-filter</v-icon>
                                                    </v-badge>
                                                </v-btn>
                                            </template>
                                            <span>Filtro Personalizado</span>
                                        </v-tooltip>
                                    </template>
                                    <custom-filter-estudiante
                                        v-if="filtroMenu"
                                        :internal-state="filterInternalState"
                                        @applyFilter="applyFilter"
                                    ></custom-filter-estudiante>
                                </v-menu>

                                <!--<v-menu
                                    v-model="exportMenu"
                                    origin="center center"
                                    class="elelvation-1"
                                    transition="slide-y-transition"
                                    left
                                    max-width="350"
                                    max-height="500"
                                    :close-on-content-click="false"
                                >
                                    <template v-slot:activator="{ on: menu }">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on: tooltip }">
                                                <v-btn icon flat>
                                                    <v-icon medium v-on="{ ...tooltip, ...menu }">fa fa-save</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Exportar Estudiantes</span>
                                        </v-tooltip>
                                    </template>
                                    <v-card>
                                        <v-card-text pb-0>
                                            <v-text-field v-model="filename" label="Nombre del documento">
                                            </v-text-field>
                                            <v-text-field v-model="sheetname" label="Nombre de la hoja"> </v-text-field>

                                            <v-flex sm12 class="pb-3">
                                                <v-label>Columnas a exportar</v-label>
                                            </v-flex>
                                            <v-container fluid grid-list-xl py-0>
                                                <v-layout align-center wrap>
                                                    <v-flex
                                                        xs12
                                                        sm6
                                                        class="pa-0"
                                                        v-for="column in excelColumns"
                                                        :key="column.field"
                                                    >
                                                        <v-checkbox
                                                            v-model="column.status"
                                                            class="pt-0 mt-0"
                                                            :label="column.label"
                                                            :key="column.field"
                                                        >
                                                        </v-checkbox>
                                                    </v-flex>
                                                </v-layout>
                                            </v-container>
                                        </v-card-text>
                                        <v-divider></v-divider>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="red" flat @click="exportMenu = false">
                                                Cancelar
                                            </v-btn>
                                            <v-btn color="success" flat>
                                                Exportar
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-menu>-->

                                <input
                                    ref="fileImportPagos"
                                    id="file"
                                    type="file"
                                    @change="onChangeImportPagos()"
                                    accept=".txt"
                                />
                                <label for="file" class="v-btn--icon icon--upload">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon medium v-on="on">fa-upload</v-icon>
                                        </template>
                                        <span>Cargar archivo de pagos</span>
                                    </v-tooltip>
                                </label>

                                <v-divider class="pa-2"></v-divider>

                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn icon flat @click="openForm(null)">
                                            <v-icon medium v-on="on">fa fa-plus</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Agregar Estudiante</span>
                                </v-tooltip>
                            </v-toolbar-items>
                        </v-toolbar>
                        <v-divider></v-divider>
                        <v-card-text class="pa-0">
                            <v-data-table
                                :headers="headers"
                                :loading="loading"
                                :pagination.sync="pagination"
                                :rows-per-page-items="pagination.rowsPerPageItems"
                                :total-items="totalItems"
                                :items="ESTUDIANTES"
                                class="elevation-1"
                                item-key="id"
                            >
                                <v-progress-linear v-slot:progress color="green" indeterminate></v-progress-linear>
                                <template slot="items" slot-scope="props">
                                    <tr>
                                        <td>{{ props.item.matricula }}</td>
                                        <td>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-icon size="20" v-on="on">{{ getSexoAvatar(props.item) }}</v-icon>
                                                </template>
                                                <span>{{ props.item.sexo.nombre }}</span>
                                            </v-tooltip>

                                            {{
                                                props.item.nombre +
                                                    " " +
                                                    props.item.apellido_paterno +
                                                    " " +
                                                    props.item.apellido_materno
                                            }}
                                        </td>
                                        <td>{{ props.item.fecha_nacido ? props.item.fecha_nacido : "-" }}</td>
                                        <td>{{ props.item.fecha_alta ? props.item.fecha_alta : "-" }}</td>
                                        <td>{{ props.item.countcursos ? props.item.countcursos : "-" }}</td>
                                        <td>
                                            <v-chip
                                                small
                                                dark
                                                :color="getChipColor(props.item)"
                                                style="font-size: 12px"
                                            >
                                                {{
                                                    props.item.status_description ? props.item.status_description : "-"
                                                }}
                                            </v-chip>
                                            <div class="action-column">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            flat
                                                            icon
                                                            color="grey"
                                                            :disabled="loading || menuLocked"
                                                            :to="{
                                                                    name: 'curso',
                                                                    params: { estudianteParam: props.item.id }
                                                                }"
                                                        >
                                                            <v-icon medium v-on="on">fa-graduation-cap </v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Ver Cursos</span>
                                                </v-tooltip>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            flat
                                                            icon
                                                            color="red"
                                                            :disabled="loading || menuLocked"
                                                            @click="deleteItem(props)"
                                                        >
                                                            <v-icon medium v-on="on">fa-trash</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Eliminar Estudiante</span>
                                                </v-tooltip>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            flat
                                                            icon
                                                            color="primary"
                                                            :disabled="loading || menuLocked"
                                                            @click="expandRow(props)"
                                                        >
                                                            <v-icon medium v-on="on">fa-list</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Opciones</span>
                                                </v-tooltip>
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                                <template v-slot:expand="props">
                                    <v-card>
                                        <v-card-text class="py-0 pl-0 text-xs-right">
                                            <template v-if="rowExpandedOption === 2">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn flat icon color="grey" @click="openDetails(props)">
                                                            <v-icon medium v-on="on">fa fa-eye</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Ver detalles</span>
                                                </v-tooltip>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn flat icon color="orange" @click="openForm(props)">
                                                            <v-icon medium v-on="on">fa fa-edit</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Editar Estudiante</span>
                                                </v-tooltip>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            flat
                                                            icon
                                                            color="grey"
                                                            :loading="loadingHistory"
                                                            @click="loadHistory(props)"
                                                        >
                                                            <v-icon medium v-on="on">fa-archive</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Ver historial</span>
                                                </v-tooltip>
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn flat icon color="grey" @click="downloadFilePagos(props)">
                                                            <v-icon medium v-on="on">fa-download</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Descargar modelo de pago</span>
                                                </v-tooltip>
                                            </template>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn icon flat color="red" @click="deleteItemCancel(props)">
                                                        <v-icon v-on="on">fa-close</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Cancelar acción</span>
                                            </v-tooltip>
                                            <template v-if="rowExpandedOption === 1">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            icon
                                                            flat
                                                            color="green"
                                                            @click="deleteItemConfirm(props)"
                                                        >
                                                            <v-icon v-on="on">fa-check</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Confirmar acción</span>
                                                </v-tooltip>
                                            </template>
                                        </v-card-text>
                                    </v-card>
                                </template>
                                <template slot="no-data">
                                    <div style="text-align: center">
                                        No existen estudiantes registrados en el sistema.
                                    </div>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <estudiante-form v-if="showForm" :form-title="title" :initial-item="editItem" @formCanceled="closeForm">
        </estudiante-form>
        <estudiante-details v-if="showDetails" :item="detailsItem" @detailsCanceled="closeDetails">
        </estudiante-details>

        <time-line
            v-if="showHistory"
            :data="historyData"
            :element="'Estudiante'"
            @formCanceled="showHistory = false"
        ></time-line>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import _ from "lodash"
import Util from "@/util"
import Vue from "vue"
const TimeLine = () =>
    import(/* webpackChunkName: "historial-time-line" */ "@/components/widgets/records-time-line/time-line")
const CustomFilterEstudiante = () =>
    import(/* webpackChunkName: "estudiante-filter" */ "@/components/widgets/custom-filter-estudiante/custom-filter-estudiante")
const EstudianteForm = () =>
    import(/* webpackChunkName: "estudiante-form" */ "@/components/cobranza/estudiante/estudiante-form")
const EstudianteDetails = () =>
    import(/* webpackChunkName: "estudiante-details" */ "@/components/cobranza/estudiante/estudiante-details")

export default {
    components: { CustomFilterEstudiante, EstudianteDetails, EstudianteForm, TimeLine },
    props: {
        estado: { type: String, default: null }
    },
    data: () => ({
        searchShow: false,
        loading: false,
        title: "",
        showForm: false,
        headers: [
            { text: "Matrícula", value: "matricula" },
            { text: "Estudiante", value: "nombre" },
            { text: "Fecha nacido", value: "fecha_nacido" },
            { text: "Fecha alta", value: "fecha_alta" },
            { text: "Cursos", value: "countcursos" },
            { text: "Estado", value: "estado" }
        ],
        editItem: null,
        filter: {
            search: ""
        },
        totalItems: 0,

        deleteEstudianteConfirmId: "",

        menuLocked: false,

        showDetails: false,
        detailsItem: null,

        //menu exportar
        exportMenu: false,
        excelColumns: Util.EstudianteExcelColumns(),
        filename: "estudiantes",
        sheetname: "seleccion",

        //filtro personalizado
        filtroMenu: false,
        customFilter: null,
        activeFilters: 0,
        camposFilter: Util.EstudianteCampos(),

        //estado de los estudiantes a cargar del back
        estudianteEstado: "1",

        //si la fila esta expandida. 1 si es para eliminar, 2 si es para mostrar las opciones
        rowExpandedOption: null,

        //history
        loadingHistory: false,
        showHistory: false,
        historyData: null,

        //para saber si ya se aplico el valor obtenido por las props
        estadoApplied: false,

        //archivo de pagos para importar
        fileImportPagos: null,

        //estado interno del filtro
        filterInternalState: null
    }),

    methods: {
        toogleSearch: function() {
            this.searchShow = !this.searchShow
        },

        loadData(estado, customFilter) {
            this.loading = true
            this.$store
                .dispatch("LOAD_ESTUDIANTES", {
                    filter: this.filter.search,
                    estudianteEstado: estado,
                    customfilter: customFilter
                })
                .then(result => {
                    this.loading = false
                    this.totalItems = result
                })
        },

        openForm(props) {
            if (props !== null) {
                this.title = "Modificar estudiante"
                this.editItem = props.item
                this.expandRowCancel(props)
            } else {
                this.title = "Nuevo estudiante"
            }
            this.showForm = true
        },

        closeForm() {
            this.showForm = false
            this.editItem = null
        },

        deleteItem(props) {
            this.menuLocked = true
            this.deleteEstudianteConfirmId = props.item.id
            this.rowExpandedOption = 1
            props.expanded = true
        },

        deleteItemConfirm(props) {
            if (this.deleteEstudianteConfirmId === props.item.id) {
                this.loading = true
                this.$store.dispatch("DELETE_ESTUDIANTE", props.item).then(() => {
                    this.loading = false
                    this.menuLocked = false
                    this.deleteEstudianteConfirmId = ""
                    props.expanded = !props.expanded
                })
            }
        },

        deleteItemCancel(props) {
            this.menuLocked = false
            this.deleteEstudianteConfirmId = ""
            props.expanded = !props.expanded
        },

        loadEstudiante() {
            this.loadData(this.estudianteEstado)
            this.customFilter = null
            this.activeFilters = 0
        },

        searchData: _.debounce(function() {
            this.loadData(this.estudianteEstado, this.customfilter)
        }, 1000),

        closeDetails() {
            this.showDetails = false
            this.detailsItem = null
        },

        openDetails(props) {
            let estudiante = this.ESTUDIANTES.filter(el => el.id === props.item.id)[0]
            if (estudiante.image || estudiante.image === null) {
                this.detailsItem = props.item
                this.showDetails = true
            } else {
                //condicion para saber si los datos de este empleado no se han cargaron para pedirlos
                this.loading = true
                this.$store.dispatch("LOAD_ESTUDIANTE_DETAILS", props.item).then(error => {
                    if (error === null) {
                        this.detailsItem = props.item
                        this.loading = false
                        this.showDetails = true
                    } else {
                        this.loading = false
                    }
                })
            }
            this.expandRowCancel(props)
        },

        applyFilter(value) {
            if (value.activeFilters > 0) {
                this.filtroMenu = false
                this.estudianteEstado = "6"
                this.customfilter = value.customFilter
                this.activeFilters = value.activeFilters
                this.loadData(this.estudianteEstado, this.customfilter)
            } else {
                this.estudianteEstado = "1"
                this.customfilter = null
                this.activeFilters = 0
                this.loadData(this.estudianteEstado, this.customfilter)
                this.filtroMenu = false
            }

            this.filterInternalState = {
                inputs: value.internalState.inputs,
                selectedCampos: value.internalState.selectedCampos
            }
        },

        expandRow(props) {
            this.menuLocked = true
            this.rowExpandedOption = 2
            props.expanded = !props.expanded
        },

        loadHistory(props) {
            this.loadingHistory = true

            let historyClassName = Util.getHistoryClassName("Estudiante")
            this.$store.commit("SET_HISTORIALES_TIME_LINE_PAG", { page: 1 })
            this.$store
                .dispatch("LOAD_HISTORIALES_TIME_LINE", { class: historyClassName, class_id: props.item.id })
                .then(response => {
                    if (response) {
                        this.historyData = this.$store.getters.HISTORIALES_TIME_LINE.historiales
                        this.showHistory = true
                        this.loadingHistory = false
                        this.expandRowCancel(props)
                    } else {
                        this.loadingHistory = false
                        this.expandRowCancel(props)
                    }
                })
        },

        expandRowCancel(props) {
            props.expanded = !props.expanded
            this.menuLocked = false
        },

        onChangeImportPagos() {
            this.fileImportPagos = this.$refs.fileImportPagos.files[0]

            if (this.fileImportPagos && Util.validateFile(this.fileImportPagos.name, ["txt"])) {
                this.loading = true

                let importPagos = new FormData()
                importPagos.append("UploadForm[file]", this.fileImportPagos)
                this.$store.dispatch("UPLOAD_PAGOS_FILE_ESTUDIANTES", importPagos).then(response => {
                    if (response) {
                        this.loadEstudiante()
                    }
                })
                this.loading = false
            } else {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Validación",
                    text:
                        "El archivo para importar los pagos debe ser un documento de texto con extensión txt, inténtelo nuevamente"
                })
            }
        },

        downloadFilePagos(props) {
            this.$store.dispatch("DOWNLOAD_MODELO_PAGO_ESTUDIANTE", props.item).then(response => {
                if (response) {
                    let blob = new Blob([response], { type: response.type })
                    let link = document.createElement("a")
                    link.href = window.URL.createObjectURL(blob)
                    link.download = props.item.matricula
                    link.click()

                    Vue.notify({
                        group: "pages",
                        type: "success",
                        title: "Solicitud de pago",
                        text: "El modelo de pago ha sido descargado satisfactoriamente"
                    })
                }
            })
        },

        getSexoAvatar(item) {
            switch (item.sexo.nombre.toLowerCase()) {
                case "masculino":
                    return "fa-male"
                case "femenino":
                    return "fa-female"
                default:
                    return "fa-user"
            }
        },

        getIconColor(data) {
            switch (data.item.value) {
                case "1":
                    return "black"
                case "2":
                    return "success lighten-1"
                case "3":
                    return "grey lighten-1"
                default:
                    return "black"
            }
        },

        getChipColor(item) {
            switch (item.estado) {
                case 1:
                    return "success lighten-1"
                case 0:
                    return "grey lighten-1"
            }
        }
    },

    computed: {
        ...mapGetters(["ESTUDIANTES"]),

        pagination: {
            get: function() {
                return this.$store.getters.ESTUDIANTES_PAG
            },
            set: function(value) {
                this.$store.commit("SET_ESTUDIANTES_PAG", value)
            }
        },
        searchTerm() {
            return this.filter.search
        },

        computedExcelColumns() {
            return this.excelColumns.filter(el => el.status)
        }
    },

    watch: {
        pagination: {
            handler() {
                if (this.estado && !this.estadoApplied) {
                    //si se envio el valor estado por las props y no se ha aplicado, se aplica una sola vez
                    this.estudianteEstado = this.estado
                    this.estadoApplied = true
                }
                this.loadData(this.estudianteEstado, this.customfilter)
            },
            deep: true
        },
        searchTerm() {
            this.searchData()
        }
    }
}
</script>

<style scoped>
input[type="file"] {
    display: none;
}
.icon--upload {
    font-size: 13px;
    height: 35px;
    padding-left: 4px;
    padding-top: 1px;
    margin-top: 15px;
    cursor: pointer;
}
.icon--upload:hover {
    background-color: #61b865;
}
</style>
